/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M8.4801 5.8262A.75.75 0 0 0 7.52 4.6738L3.8285 7.75l3.6914 3.0762A.75.75 0 0 0 8.48 9.6738L6.1715 7.75l2.3086-1.9238ZM15.4238 10.7301a.75.75 0 0 1 .0961-1.0563L17.8285 7.75l-2.3086-1.9238a.75.75 0 0 1 .9602-1.1524L20.1715 7.75l-3.6914 3.0762a.75.75 0 0 1-1.0563-.0961ZM13.7048 5.5063a.75.75 0 0 0-.4485-.9611.75.75 0 0 0-.9611.4485l-2 5.5a.7498.7498 0 0 0 .4485.9611.7498.7498 0 0 0 .9611-.4485l2-5.5Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.75 7.75v8.5c0 2.1676-1.4821 3.9961-3.5903 5.2419C18.0348 22.7475 15.1481 23.5 12 23.5c-3.1481 0-6.0348-.7525-8.1597-2.0081C1.732 20.2461.25 18.4176.25 16.25v-8.5c0-2.1676 1.482-3.9961 3.5903-5.2419C5.9653 1.2524 8.8519.5 12 .5c3.1481 0 6.0348.7525 8.1597 2.0081C22.2679 3.754 23.75 5.5824 23.75 7.75Zm-22 0c0-1.4223.9804-2.8437 2.8534-3.9505C6.4596 2.7026 9.073 2 12 2c2.927 0 5.5404.7026 7.3966 1.7995C21.2697 4.9063 22.25 6.3277 22.25 7.75s-.9803 2.8437-2.8534 3.9505C17.5404 12.7974 14.927 13.5 12 13.5c-2.927 0-5.5404-.7026-7.3966-1.7995C2.7304 10.5937 1.75 9.1723 1.75 7.75Zm18.4097 5.2419c.8035-.4748 1.5161-1.0343 2.0903-1.6649v.423c0 1.4223-.9803 2.8437-2.8534 3.9505C17.5404 16.7974 14.927 17.5 12 17.5c-2.927 0-5.5404-.7026-7.3966-1.7995C2.7304 14.5937 1.75 13.1723 1.75 11.75v-.423c.5742.6306 1.2868 1.1901 2.0903 1.6649C5.9653 14.2475 8.8519 15 12 15c3.1481 0 6.0348-.7525 8.1597-2.0081Zm0 4c.8035-.4748 1.5161-1.0343 2.0903-1.6649v.923c0 1.4223-.9803 2.8437-2.8534 3.9505C17.5404 21.2974 14.927 22 12 22c-2.927 0-5.5404-.7026-7.3966-1.7995C2.7304 19.0937 1.75 17.6723 1.75 16.25v-.923c.5742.6306 1.2868 1.1901 2.0903 1.6649C5.9653 18.2475 8.8519 19 12 19c3.1481 0 6.0348-.7525 8.1597-2.0081Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuVectorDB'
);
